function resetTypeFilters() {
  this.$data.settings.filters.typesSelected = false;
  this.$data.settings.filtersText.typesText = false;
  this.$data.settings.filtersValues.typesVal = [];
}
export default resetTypeFilters;
